//Use this as a Model for future Entities
//import { AppUserInfoRepository } from 'data/service/app-user-info-repository';
import { Entity, resource, repository } from 'aurelia-orm';
import { AppRepository } from '../app-repository';

@resource("AppUserInfo")
@repository(AppRepository)
export class AppUserInfo extends Entity {
	id: number;
	firstName: string;
	lastName: string;
	insertedOn: Date;
	fullName: string;
	isActive: boolean;
	isAdmin: boolean;
	isOwner: boolean;
	notificationOptionId: number;
	emailNotificationOptionId: number;
	sortNotificationsByDateDescending: boolean;
	sortCommentsByDateDescending: boolean;
	hideHelp: boolean;
	isExpandNotificationPanel: boolean;
	isSearchResultPanel: boolean;
}